// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/activity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.activity";

export enum ActorType {
  ACTOR_TYPE_UNSPECIFIED = 0,
  ACTOR_TYPE_USER = 1,
  ACTOR_TYPE_AGENT = 2,
  ACTOR_TYPE_INTEGRATION = 3,
}

export function actorTypeFromJSON(object: any): ActorType {
  switch (object) {
    case 0:
    case "ACTOR_TYPE_UNSPECIFIED":
      return ActorType.ACTOR_TYPE_UNSPECIFIED;
    case 1:
    case "ACTOR_TYPE_USER":
      return ActorType.ACTOR_TYPE_USER;
    case 2:
    case "ACTOR_TYPE_AGENT":
      return ActorType.ACTOR_TYPE_AGENT;
    case 3:
    case "ACTOR_TYPE_INTEGRATION":
      return ActorType.ACTOR_TYPE_INTEGRATION;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ActorType");
  }
}

export function actorTypeToJSON(object: ActorType): string {
  switch (object) {
    case ActorType.ACTOR_TYPE_UNSPECIFIED:
      return "ACTOR_TYPE_UNSPECIFIED";
    case ActorType.ACTOR_TYPE_USER:
      return "ACTOR_TYPE_USER";
    case ActorType.ACTOR_TYPE_AGENT:
      return "ACTOR_TYPE_AGENT";
    case ActorType.ACTOR_TYPE_INTEGRATION:
      return "ACTOR_TYPE_INTEGRATION";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ActorType");
  }
}

/** Activity - represents a tracked change to an entity */
export interface Activity {
  /** Unique identifier (server-assigned cuid) */
  id: string;
  /** Company this activity belongs to */
  companyId: number;
  /** Entity: "project", "document", "task", etc. */
  entity: string;
  /** ID of the entity (reference to the corresponding data source) */
  entityId: string;
  /**
   * If user-initiated, user that kicked off the action.
   * Empty string if actor is unknown or it was not user-initiated such as from an automated integration
   */
  actorId: string;
  /** Type of activity, e.g. "create", "edit", "delete" */
  activityType: string;
  /** When the activity occurred */
  createdAt:
    | Date
    | undefined;
  /**
   * General purpose details not yet added as a top level field
   * Examples: human-readable short summary, mini diff or diagnosis information, or
   * other metadata that could be used to render a rich Activity history entry
   * (e.g. AGENT actor's agent name, or INTEGRATION actor's JIRA issue ID)
   */
  details:
    | ActivityDetails
    | undefined;
  /** If applicable, project ID to support search indexed by project */
  projectId?:
    | string
    | undefined;
  /**
   * If this activity is related to an update affecting multiple entities, an ID that tie the changes together
   * If actor_type is AGENT, this id would be a "run_id" for example
   */
  batchUpdateId?:
    | string
    | undefined;
  /** ActorType to distinguish user-initiated activity from direct edits by a user */
  actorType: ActorType;
  /** If this activity represents an update or deletion, the content before the change, so it can be recovered */
  content?: string | undefined;
}

/**
 * Caller-provided context for recording an Activity entry.
 * These fields map directly to the corresponding Activity fields and are
 * passed through the call stack to the activity store where they are
 * written into an Activity record. Fields not present here (e.g. entity,
 * entity_id, activity_type, summary) are derived at the recording site.
 */
export interface ActivityRecordContext {
  /** Who performed the action (maps to Activity.actor_type) */
  actorType: ActorType;
  /** User ID of the actor, if user-initiated (maps to Activity.actor_id) */
  actorId?:
    | string
    | undefined;
  /** Scoping project, if applicable (maps to Activity.project_id) */
  projectId?:
    | string
    | undefined;
  /** Groups related multi-entity changes, e.g. an agent run_id (maps to Activity.batch_update_id) */
  batchUpdateId?:
    | string
    | undefined;
  /** Additional details (data here will depend on the caller but should be escaped JSON that we can feed into Activity.details.context) */
  details?: string | undefined;
}

/** ActivityDetails - data stored in details JSONB column */
export interface ActivityDetails {
  /** Short human-readable summary to help operators scan the meaning of the change */
  summary: string;
  /** Additional context (data here will depend on activity_type but should be escaped JSON) */
  context?: string | undefined;
}

/** ActivityFilters - filter conditions when querying activity entries. */
export interface ActivityFilters {
  /** Filter by entity type (e.g., "project", "document"). Empty = all. */
  entity?:
    | string
    | undefined;
  /** Filter by entity ID. Empty = all. */
  entityId?:
    | string
    | undefined;
  /** Filter by activity types (e.g., "edit", "status_change"). Empty = all. */
  activityTypes: string[];
  /** Filter by actor IDs. Empty = all. */
  actorIds: string[];
  /** Filter activities created after this time */
  startDate?:
    | Date
    | undefined;
  /** Filter activities created before this time */
  endDate?:
    | Date
    | undefined;
  /** Max results (default: 50, max: 100) */
  limit?:
    | number
    | undefined;
  /** Pagination cursor from previous response */
  cursor?: string | undefined;
}

function createBaseActivity(): Activity {
  return {
    id: "",
    companyId: 0,
    entity: "",
    entityId: "",
    actorId: "",
    activityType: "",
    createdAt: undefined,
    details: undefined,
    projectId: undefined,
    batchUpdateId: undefined,
    actorType: 0,
    content: undefined,
  };
}

export const Activity: MessageFns<Activity> = {
  encode(message: Activity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.entity !== "") {
      writer.uint32(26).string(message.entity);
    }
    if (message.entityId !== "") {
      writer.uint32(34).string(message.entityId);
    }
    if (message.actorId !== "") {
      writer.uint32(42).string(message.actorId);
    }
    if (message.activityType !== "") {
      writer.uint32(50).string(message.activityType);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.details !== undefined) {
      ActivityDetails.encode(message.details, writer.uint32(66).fork()).join();
    }
    if (message.projectId !== undefined) {
      writer.uint32(74).string(message.projectId);
    }
    if (message.batchUpdateId !== undefined) {
      writer.uint32(82).string(message.batchUpdateId);
    }
    if (message.actorType !== 0) {
      writer.uint32(88).int32(message.actorType);
    }
    if (message.content !== undefined) {
      writer.uint32(98).string(message.content);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Activity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.entity = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.actorId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.activityType = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.details = ActivityDetails.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.batchUpdateId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.actorType = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.content = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Activity {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      entity: isSet(object.entity) ? globalThis.String(object.entity) : "",
      entityId: isSet(object.entityId)
        ? globalThis.String(object.entityId)
        : isSet(object.entity_id)
        ? globalThis.String(object.entity_id)
        : "",
      actorId: isSet(object.actorId)
        ? globalThis.String(object.actorId)
        : isSet(object.actor_id)
        ? globalThis.String(object.actor_id)
        : "",
      activityType: isSet(object.activityType)
        ? globalThis.String(object.activityType)
        : isSet(object.activity_type)
        ? globalThis.String(object.activity_type)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      details: isSet(object.details) ? ActivityDetails.fromJSON(object.details) : undefined,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      batchUpdateId: isSet(object.batchUpdateId)
        ? globalThis.String(object.batchUpdateId)
        : isSet(object.batch_update_id)
        ? globalThis.String(object.batch_update_id)
        : undefined,
      actorType: isSet(object.actorType)
        ? actorTypeFromJSON(object.actorType)
        : isSet(object.actor_type)
        ? actorTypeFromJSON(object.actor_type)
        : 0,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
    };
  },

  toJSON(message: Activity): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.entity !== "") {
      obj.entity = message.entity;
    }
    if (message.entityId !== "") {
      obj.entityId = message.entityId;
    }
    if (message.actorId !== "") {
      obj.actorId = message.actorId;
    }
    if (message.activityType !== "") {
      obj.activityType = message.activityType;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.details !== undefined) {
      obj.details = ActivityDetails.toJSON(message.details);
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.batchUpdateId !== undefined) {
      obj.batchUpdateId = message.batchUpdateId;
    }
    if (message.actorType !== 0) {
      obj.actorType = actorTypeToJSON(message.actorType);
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    return obj;
  },

  create(base?: DeepPartial<Activity>): Activity {
    return Activity.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Activity>): Activity {
    const message = createBaseActivity();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.entity = object.entity ?? "";
    message.entityId = object.entityId ?? "";
    message.actorId = object.actorId ?? "";
    message.activityType = object.activityType ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? ActivityDetails.fromPartial(object.details)
      : undefined;
    message.projectId = object.projectId ?? undefined;
    message.batchUpdateId = object.batchUpdateId ?? undefined;
    message.actorType = object.actorType ?? 0;
    message.content = object.content ?? undefined;
    return message;
  },
};

function createBaseActivityRecordContext(): ActivityRecordContext {
  return { actorType: 0, actorId: undefined, projectId: undefined, batchUpdateId: undefined, details: undefined };
}

export const ActivityRecordContext: MessageFns<ActivityRecordContext> = {
  encode(message: ActivityRecordContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.actorType !== 0) {
      writer.uint32(8).int32(message.actorType);
    }
    if (message.actorId !== undefined) {
      writer.uint32(18).string(message.actorId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(26).string(message.projectId);
    }
    if (message.batchUpdateId !== undefined) {
      writer.uint32(34).string(message.batchUpdateId);
    }
    if (message.details !== undefined) {
      writer.uint32(42).string(message.details);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActivityRecordContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivityRecordContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.actorType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.actorId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.batchUpdateId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.details = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivityRecordContext {
    return {
      actorType: isSet(object.actorType)
        ? actorTypeFromJSON(object.actorType)
        : isSet(object.actor_type)
        ? actorTypeFromJSON(object.actor_type)
        : 0,
      actorId: isSet(object.actorId)
        ? globalThis.String(object.actorId)
        : isSet(object.actor_id)
        ? globalThis.String(object.actor_id)
        : undefined,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      batchUpdateId: isSet(object.batchUpdateId)
        ? globalThis.String(object.batchUpdateId)
        : isSet(object.batch_update_id)
        ? globalThis.String(object.batch_update_id)
        : undefined,
      details: isSet(object.details) ? globalThis.String(object.details) : undefined,
    };
  },

  toJSON(message: ActivityRecordContext): unknown {
    const obj: any = {};
    if (message.actorType !== 0) {
      obj.actorType = actorTypeToJSON(message.actorType);
    }
    if (message.actorId !== undefined) {
      obj.actorId = message.actorId;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.batchUpdateId !== undefined) {
      obj.batchUpdateId = message.batchUpdateId;
    }
    if (message.details !== undefined) {
      obj.details = message.details;
    }
    return obj;
  },

  create(base?: DeepPartial<ActivityRecordContext>): ActivityRecordContext {
    return ActivityRecordContext.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ActivityRecordContext>): ActivityRecordContext {
    const message = createBaseActivityRecordContext();
    message.actorType = object.actorType ?? 0;
    message.actorId = object.actorId ?? undefined;
    message.projectId = object.projectId ?? undefined;
    message.batchUpdateId = object.batchUpdateId ?? undefined;
    message.details = object.details ?? undefined;
    return message;
  },
};

function createBaseActivityDetails(): ActivityDetails {
  return { summary: "", context: undefined };
}

export const ActivityDetails: MessageFns<ActivityDetails> = {
  encode(message: ActivityDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.summary !== "") {
      writer.uint32(10).string(message.summary);
    }
    if (message.context !== undefined) {
      writer.uint32(18).string(message.context);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActivityDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivityDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.context = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivityDetails {
    return {
      summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
      context: isSet(object.context) ? globalThis.String(object.context) : undefined,
    };
  },

  toJSON(message: ActivityDetails): unknown {
    const obj: any = {};
    if (message.summary !== "") {
      obj.summary = message.summary;
    }
    if (message.context !== undefined) {
      obj.context = message.context;
    }
    return obj;
  },

  create(base?: DeepPartial<ActivityDetails>): ActivityDetails {
    return ActivityDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ActivityDetails>): ActivityDetails {
    const message = createBaseActivityDetails();
    message.summary = object.summary ?? "";
    message.context = object.context ?? undefined;
    return message;
  },
};

function createBaseActivityFilters(): ActivityFilters {
  return {
    entity: undefined,
    entityId: undefined,
    activityTypes: [],
    actorIds: [],
    startDate: undefined,
    endDate: undefined,
    limit: undefined,
    cursor: undefined,
  };
}

export const ActivityFilters: MessageFns<ActivityFilters> = {
  encode(message: ActivityFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entity !== undefined) {
      writer.uint32(10).string(message.entity);
    }
    if (message.entityId !== undefined) {
      writer.uint32(18).string(message.entityId);
    }
    for (const v of message.activityTypes) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.actorIds) {
      writer.uint32(34).string(v!);
    }
    if (message.startDate !== undefined) {
      Timestamp.encode(toTimestamp(message.startDate), writer.uint32(42).fork()).join();
    }
    if (message.endDate !== undefined) {
      Timestamp.encode(toTimestamp(message.endDate), writer.uint32(50).fork()).join();
    }
    if (message.limit !== undefined) {
      writer.uint32(56).int32(message.limit);
    }
    if (message.cursor !== undefined) {
      writer.uint32(66).string(message.cursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActivityFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivityFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entity = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.activityTypes.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actorIds.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.startDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.endDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivityFilters {
    return {
      entity: isSet(object.entity) ? globalThis.String(object.entity) : undefined,
      entityId: isSet(object.entityId)
        ? globalThis.String(object.entityId)
        : isSet(object.entity_id)
        ? globalThis.String(object.entity_id)
        : undefined,
      activityTypes: globalThis.Array.isArray(object?.activityTypes)
        ? object.activityTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.activity_types)
        ? object.activity_types.map((e: any) => globalThis.String(e))
        : [],
      actorIds: globalThis.Array.isArray(object?.actorIds)
        ? object.actorIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.actor_ids)
        ? object.actor_ids.map((e: any) => globalThis.String(e))
        : [],
      startDate: isSet(object.startDate)
        ? fromJsonTimestamp(object.startDate)
        : isSet(object.start_date)
        ? fromJsonTimestamp(object.start_date)
        : undefined,
      endDate: isSet(object.endDate)
        ? fromJsonTimestamp(object.endDate)
        : isSet(object.end_date)
        ? fromJsonTimestamp(object.end_date)
        : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : undefined,
    };
  },

  toJSON(message: ActivityFilters): unknown {
    const obj: any = {};
    if (message.entity !== undefined) {
      obj.entity = message.entity;
    }
    if (message.entityId !== undefined) {
      obj.entityId = message.entityId;
    }
    if (message.activityTypes?.length) {
      obj.activityTypes = message.activityTypes;
    }
    if (message.actorIds?.length) {
      obj.actorIds = message.actorIds;
    }
    if (message.startDate !== undefined) {
      obj.startDate = message.startDate.toISOString();
    }
    if (message.endDate !== undefined) {
      obj.endDate = message.endDate.toISOString();
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit);
    }
    if (message.cursor !== undefined) {
      obj.cursor = message.cursor;
    }
    return obj;
  },

  create(base?: DeepPartial<ActivityFilters>): ActivityFilters {
    return ActivityFilters.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ActivityFilters>): ActivityFilters {
    const message = createBaseActivityFilters();
    message.entity = object.entity ?? undefined;
    message.entityId = object.entityId ?? undefined;
    message.activityTypes = object.activityTypes?.map((e) => e) || [];
    message.actorIds = object.actorIds?.map((e) => e) || [];
    message.startDate = object.startDate ?? undefined;
    message.endDate = object.endDate ?? undefined;
    message.limit = object.limit ?? undefined;
    message.cursor = object.cursor ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
